<div class="field">
  <label *ngIf="label" class="weight-medium is-uppercase">{{ label }}</label>

  <div class="control" [formGroup]="form">
    <div [ngClass]="{ 'cursor-forbidden': disabled }" class="input-group">
      <input
        [formControlName]="inputName"
        [name]="inputName"
        [class.is-disabled]="disabled"
        [tabindex]="disabled ? '-1' : 0"
        [type]="buttonPreview ? dynamicType : type"
        [maxlength]="maxLength"
        [minlength]="minLength"
        [value]="value"
        [class.is-uppercase]="uppercase"
        [class.is-tall]="tall"
        [ngClass]="{
          'is-danger':
            error ||
            (submitted &&
              (getControl()?.touched || getControl()?.dirty) &&
              (getControl().errors?.required || getControl().errors?.minlength)),
          'form-control': buttonPreview
        }"
        placeholder="{{ placeholder }}"
        class="input"
        autocomplete="off"
        (change)="valueChange.emit(true)"
        (keyup)="keyUp.emit(true)"
        (keypress)="handleKeypress($event.key)"
      />
      <!-- <div *ngIf="buttonPreview" class="input-group-append">
        <span class="input-group-text h100" (click)="toggleTextPreview()">
          <i
            class="fa"
            [ngClass]="{
              'fa-eye': !showInputText,
              'fa-eye-slash': showInputText
            }"
          ></i>
        </span>
      </div> -->
    </div>

    <div *ngIf="getControl()?.invalid && (getControl()?.touched || getControl()?.dirty)">
      <div
        *ngIf="(!isEmail && submitted && getControl().errors?.required) || error"
        class="help is-danger"
      >
        {{ errorMessage }}
      </div>

      <div *ngIf="submitted && getControl().errors?.minlength" class="help is-danger">
        {{ 'errors.min-length' | translate }}
      </div>

      <div *ngIf="isEmail" class="help is-danger">
        <div *ngIf="getControl()?.errors?.['required']">Email is required.</div>
        <div *ngIf="getControl()?.errors?.['email']">Invalid email format.</div>
      </div>
    </div>
  </div>
</div>
